// A simple way to swap what backend you are pointing too

//export const API_ROOT = 'https://s5d.postreality.io'; // for testing from a local machine, or if backend is not on the same URL
export const API_ROOT = '';    // if backend is at the same domain as front end